import type { FC } from 'react';

type IconProps = {
    className?: string;
};

/**
 * シンプルなロックアイコン
 */
export const LockIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <rect
            x="5"
            y="10"
            width="14"
            height="10"
            rx="2"
            stroke="currentColor"
            strokeWidth="2"
        />
        <path
            d="M9 10V8a3 3 0 0 1 6 0v2"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="12" cy="15" r="1.4" fill="currentColor" />
    </svg>
);


